import { useState } from "react";
import ChatHeader from "./ChatHeader";
import MessageList from "./MessageList";
import ChatInput from "./ChatInput";
import { useWidgetTheme } from "../../hooks/useWidgetTheme";
import { useChatMessages } from "../../hooks/useChatMessages";
import { useChatAPI } from "../../hooks/useChatAPI";
import styles from "./ChatWidgetContainer.module.css";

const ChatWidgetContainer = ({ apiKey, apiUrl, theme }) => {
  const [inputMessage, setInputMessage] = useState("");

  useWidgetTheme(theme);
  const {
    messages,
    messagesEndRef,
    addMessage,
    updateLastMessage,
    removeLastMessage,
  } = useChatMessages();
  const { isLoading, error, sendMessage } = useChatAPI(
    apiKey,
    apiUrl
  );

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleSendMessage = () => {
    const userMessage = inputMessage.trim();

    if (!userMessage || isLoading) {
      return;
    }

    setInputMessage("");

    const newUserMessage = {
      role: "user",
      content: userMessage,
      timestamp: new Date(),
    };
    addMessage(newUserMessage);

    const aiMessagePlaceholder = {
      role: "assistant",
      content: "",
      isLoading: true,
      timestamp: new Date(),
    };
    addMessage(aiMessagePlaceholder);

    sendMessage(
      userMessage,
      (aiResponse, model) => {
        updateLastMessage(() => ({
          role: "assistant",
          content: aiResponse,
          isLoading: false,
          timestamp: new Date(),
          model,
        }));
      },
      () => {
        removeLastMessage();
      }
    );
  };

  const handleClose = () => {
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(
          { type: "dressai-chat-widget-close" },
          // Важно: targetOrigin должен соответствовать origin "родителя".
          // Внутри iframe это `window.location.origin` (iframe origin),
          // из-за чего браузер может блокировать доставку сообщения.
          // Родитель дополнительно валидирует `event.origin`, так что безопасность сохраняется.
          "*"
        );
      }
    } catch (error) {
      // Безопасный лог в консоль, чтобы не ломать работу виджета
      // eslint-disable-next-line no-console
      console.error("Failed to post close message to parent window", error);
    }
  };

  return (
    <div className={styles.container}>
      <ChatHeader onClose={handleClose} />

      {error && <div className={styles.error}>{error}</div>}

      <MessageList
        messages={messages}
        messagesEndRef={messagesEndRef}
        formatTime={formatTime}
      />

      <ChatInput
        inputMessage={inputMessage}
        setInputMessage={setInputMessage}
        isLoading={isLoading}
        onSendMessage={handleSendMessage}
        theme={theme}
      />
    </div>
  );
};

export default ChatWidgetContainer;
